"use client";
import * as React from "react";
import Swal from "sweetalert2";
import api from "../../utils/api";
import { useNavigate } from "react-router-dom";

interface RFIDData {
  bookingDate: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  status: string | null;
  ticketBookingId: number;
  ticketNumber: string;
  ticketRFIdCardRef: string;
  ticketUniqueRFIdNo: string;
}


interface LockerTicketDetailsProps {
  cardNumber: string;
  lockerNumbers: string;
  lockerAmount: number;
  anyLockerId: number | null;
  totalBigLockers: number;
  totalSmallLockers: number;
  totalLockers: number;
  rfidData: RFIDData | null;
  lockerSecurityCharges: number;
}

export function LockerTicketDetails({  cardNumber,
  lockerNumbers,
  lockerAmount,
  anyLockerId,
  totalBigLockers,
  totalSmallLockers,
  lockerSecurityCharges,
  rfidData,
}: LockerTicketDetailsProps) {
  const [gstPercent, setGstPercent] = React.useState<number>(0);
  const gstAmount = (lockerAmount * gstPercent) / 100;
  const navigate = useNavigate();
  // Define the confirmpay handler
  const confirmpay = async () => {
    try {
      // if(!cardNumber || cardNumber.toString().length !== 10) {
      //   Swal.fire('Error!', 'Please enter a valid RF ID Card number.', 'error');
      //   return;
      // }
      if (lockerAmount <= 0) {
        Swal.fire('Error!', 'Please select at least one locker.', 'error');
        return;
      }
      // if(rfidData === null || rfidData?.ticketRFIdCardRef === null || rfidData?.ticketRFIdCardRef === undefined) {
      //   Swal.fire('Error!', 'Please scan a valid RF ID Card.', 'error');
      //   return;
      // }
      // if(rfidData?.cardAmount === undefined || rfidData?.cardAmount === null || rfidData?.cardAmount <= 0) {
      //   Swal.fire('Error!', 'Insufficient Balance or Invalid Card Amount.', 'error');
      //   return;
      // }
      // if(rfidData && rfidData?.cardAmount >= 0){
      //   if(rfidData.cardAmount < (lockerAmount + lockerSecurityCharges + gstAmount)){
      //     Swal.fire('Error!', 'Insufficient Balance!!', 'error');
      //   }
      // }
      const result = await Swal.fire({
        title: 'Confirm Locker Payment',
        html: `
        <div style="text-align:left">
          <p>Do you want to pay <b>₹${lockerAmount + gstAmount}</b> for the locker(s)?</p>
          <p><b>Ticket No.:</b> ${rfidData?.ticketRFIdCardRef}</p>
          <p><b>Customer Number:</b> ${rfidData?.customerMobileNumber}</p>          <p><b>Locker Number(s):</b> ${lockerNumbers}</p>
          <p><b>Big Lockers:</b> ${totalBigLockers}</p>
          <p><b>Small Lockers:</b> ${totalSmallLockers}</p>
          <p><b>Sub Total:</b> ₹${lockerAmount}</p>
          <p><b>GST (${gstPercent}%):</b> ₹${gstAmount.toFixed(2)}</p>
          <p><b>Grand Total:</b> ₹${(lockerAmount + lockerSecurityCharges + gstAmount).toFixed(2)}</p>
        </div>
          `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Pay',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        // Place recharge logic here
        try {
          const submittedData = {
            lockerCalculationId: 0,
            bigLocker: totalBigLockers.toString(),
            smallLocker: totalSmallLockers.toString(),
            subTotalAmount: lockerAmount,
            gst: gstAmount,
            grandTotalAmount: lockerAmount + lockerSecurityCharges + gstAmount,
            isLocked: true,
            ticketRFIdRef: rfidData?.ticketRFIdCardRef,
            selectedCard: cardNumber.toString(),
            securityMoney: lockerSecurityCharges.toFixed(2),
            lockerNumber: lockerNumbers,
            lockerId: anyLockerId,
            staffUserid: JSON.parse(localStorage.getItem('user')!).userId,
            counterid: JSON.parse(localStorage.getItem('user')!).counterid,
            customerName: rfidData?.customerName || '',
            customerMobileNumber: rfidData?.customerMobileNumber || '',
          };
          const response = await api.post('/api/LockerCalculation/AddLockerCalculation', submittedData, {
            headers: {
              'Content-Type': 'application/json',
            }
          });

          if (response.status === 200 || response.status === 201) {
            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'Locker has been assigned.',
            }).then(() => {
                navigate(`/print-locker-invoice/${response.data.lockerCalculationId}`);
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Unexpected Response',
              text: 'Please try again later.',
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Locker assigned Failed',
            text: 'Something went wrong while Locker Assign.',
          });
        }
        
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to assign the locker.', 'error');
    }
  }

  return (
    <aside className="border border-5 border-warning bg-light p-4 rounded">
      <h2 className="text-center fs-5 fw-semibold text-dark mb-4">Ticket Details</h2>

      <div className="mx-auto text-black small mb-4" style={{ maxWidth: "200px" }}>
        <p>Ticket No. - {rfidData?.ticketNumber}</p>
        <p>Customer Name - {rfidData?.customerName}</p>
        <p>Customer Number - {rfidData?.customerMobileNumber}</p>
        <p>Total Members - {Number(rfidData?.numberOdAdults) + Number(rfidData?.numberOfChildren)}</p>
        <p>NO. Of Adults - {Number(rfidData?.numberOdAdults)}</p>
        <p>Kids - {Number(rfidData?.numberOfChildren)}</p>
        {/* <p>Card Assign - xxxxxxxxxxxxxxxxx</p> */}
        {/* <p>Select Card ID - {cardNumber}</p> */}
        {/* <p>Balance - {rfidData?.cardAmount}</p> */}
      </div>

      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1941f8873fe07e7c780902338a50e0fd17627aae?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
        alt="Divider"
        className="img-fluid my-2"
      />

      <h3 className="text-center fw-semibold text-dark fs-6 my-3">Calculations</h3>

      <div className="ms-3 small text-dark">
        <p>Big Locker - {totalBigLockers}</p>
        <p>Small Locker - {totalSmallLockers}</p>
        <p>Sub Total Amount - {lockerAmount}</p>

        <div className="d-flex align-items-center mt-2 mb-2" style={{ maxWidth: "160px" }}>
          <span className="me-2">GST -</span>
          <input
            type="number"
            className="form-control form-control-sm bg-white px-3 py-1 rounded-pill fw-normal"
            style={{ width: "100px" }}
            placeholder="GST %"
            min={0}
            max={100}
            value={gstPercent}
            onChange={(e) => setGstPercent(Number(e.target.value))}
          />
        </div>
        <p>GST Amount - {gstAmount.toFixed(2)}</p>
         <p>Security Charges - {lockerSecurityCharges.toFixed(2)}</p>

        <p>Grand Total Amount - {lockerSecurityCharges + gstAmount + lockerAmount}</p>
      </div>

      <div className="d-grid mt-3 px-3">
        <button className="btn btn-primary rounded-pill fw-semibold py-2" onClick={confirmpay}>Pay</button>
      </div>
    </aside>
  );
}
